<div class="SLV2-video-card">
    <span class="SLV2-video-lst-cunt"></span>
    <div class="SLV2-video-thumb">
        <img src='{{displayImage(videoData.thumbnailURL)}}'/>
        <span class="SLV2-video-time-tag">{{displayTime(videoData.duration)}}</span>
    </div>
    <div class="SLV2-video-content-area">
        <div class="SLV2-video-info-row">
            <div class="SLV2-video-info">
                <img src="selflearnv2-ui/assets/img/eye-icon-2.svg" /><span>{{noOfViews}} views</span>
            </div>
        </div>
        <h4 class="SLV2-video-title">{{cardTitle}}</h4>
    </div>
    
</div>

